<form [formGroup]="form">
  <div class="row">
    <div class="col-md-12">
      <div class="my-3">
        <div> Description <sup class="text-danger">*</sup></div>
        <editor #tinyMceEditor
                [init]="editorOptions"
                formControlName="content"
                initialValue=""></editor>
      </div>
    </div>
  </div>
  <button class="btn btn-cst-info text-uppercase"
          (click)="onSave(form)" [disabled]="isLoading$ | async" *ngIf="!form.get('id').value; else save">
    <i class="far fa-level-down"
       style="transform: rotateY(180deg)"></i> Add To List
  </button>
  <ng-template #save>
    <button class="btn btn-outline btn-default-outline text-uppercase"
            matTooltip="Clear text editor to add a new FAQ"
            (click)="form.reset()"
            [disabled]="isLoading$ | async">
      <i class="fal fa-times"></i> Clear
    </button>
    <button class="btn btn-success text-uppercase ml-3"
            matTooltip="Save FAQ changes every time you make any change."
            (click)="onSave(form)" [disabled]="isLoading$ | async" >
      <i class="far" [ngClass]="(isLoading$ | async) ? 'fa-spin fa-spinner' : 'fa-save'" ></i> Save
    </button>
  </ng-template>
</form>
<div class="mt-4 border bg-white rounded overflow-hidden"
     *ngIf="faqItems.length > 0">
  <mat-table #table
             matSort
             multiTemplateDataRows
             [dataSource]="dataSource">
    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef
                       mat-sort-header> Title</mat-header-cell>
      <mat-cell *matCellDef="let element"
                class="text-black text-bold">
        <div class="mr-1">
          <i *ngIf="element !== expandedItem"
             class="fas fa-caret-right"></i>
          <i *ngIf="element === expandedItem"
             class="fas fa-caret-down"></i>
        </div>
        FAQ {{ getItemIndex(element.id) + 1 }}
        </mat-cell>
        </ng-container>

        <ng-container matColumnDef="preBooking">
          <mat-header-cell *matHeaderCellDef> Pre Booking</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <app-form-switch label=""
                             matTooltip="Do you really want to share this information before booking confirmation?"
                         [checked]="element.preBooking"
                         (valueChange)="onTogglePreBooking(element, $event)"></app-form-switch>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="postBooking">
      <mat-header-cell *matHeaderCellDef> Post Booking</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <app-form-switch label=""
                         matTooltip="Do you really want to share this information after booking confirmation?"
                         [checked]="element.postBooking"
                         (valueChange)="onTogglePostBooking(element, $event)"></app-form-switch>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="postCheckin">
      <mat-header-cell *matHeaderCellDef> Post Checkin</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <app-form-switch label=""
                         matTooltip="Do you really want to share this information after guest checkin?"
                         [checked]="element.postCheckin"
                         (valueChange)="onTogglePostCheckin(element, $event)"></app-form-switch>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
      <mat-cell *matCellDef="let element"
                (click)="$event.stopPropagation()">
        <a href="javascript:;"
           class=""
           matTooltip="Edit this FAQ"
           (click)="onEdit(element)"><i class="far fa-pencil"></i></a>
        <a href="javascript:;"
           class="text-danger"
           matTooltip="Delete this FAQ"
           (click)="onDelete(element.id)"><i class="far fa-trash"></i></a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="content">
      <mat-cell *matCellDef="let detail"
                class="py-3">
        <app-show-more [content]="detail.content | html2Text"
                       [maxLength]="500"></app-show-more>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"
             (click)="expandedItem = expandedItem === row ? null : row"></mat-row>
    <mat-row *matRowDef="let row; columns: ['content']"
             [@detailExpand]="row?.id == expandedItem?.id ? 'expanded' : 'collapsed'"
             style="overflow: hidden">
    </mat-row>
    </mat-table>
    <app-empty-table type="AIDocuments"
                     *ngIf="!dataSource.data?.length"></app-empty-table>

    <mat-paginator #paginator
                   [length]="dataSource?.data?.length"
                   [pageSizeOptions]="[5, 10, 20, 50]"
                   [showFirstLastButtons]="true">
    </mat-paginator>
</div>
